export type HealthRecordDocumentTypeDescriptor = {
  name: string;
  value: number;
  sortOrder: number;
}

export class HealthRecordDocumentTypesConstants {
  /**********************************************************
   * If changes are made, API code must be updated to match *
   **********************************************************/

  static readonly DOCTYPE_SURVIVOR_CARE_PLAN: number = 1;  // Must match lookup value

  static documentTypes: HealthRecordDocumentTypeDescriptor[] = [
    { value:  1, name: "Survivorship Care Plan or Summary of Cancer Treatment", sortOrder: 0 },
    { value:  3, name: "Survivor Clinic", sortOrder: 2 },
    { value:  4, name: "Oncology", sortOrder: 3 },
    { value:  5, name: "Other", sortOrder: 9 },
    { value:  9, name: "Summary of Care or Continuity Care Document", sortOrder: 1 },
    { value: 10, name: "Primary Care", sortOrder: 4 },
    { value: 11, name: "Specialist", sortOrder: 5 },
    { value: 12, name: "Labs and Other Studies", sortOrder: 6 },
    { value: 13, name: "Immunization Record", sortOrder: 7 },
    { value: 14, name: "Hospital Discharge Notice", sortOrder: 8 },
  ];

}
